
import Vue from 'vue';
import { Component } from 'vue-property-decorator';
import { getRank } from '../api';
import ActivityHeader from '../components/ActivityHeader.vue';

@Component({
  components: {
    ActivityHeader,
  },
})
export default class Rank extends Vue {
  region: any = 'Chongqing';
  list: any[] = [];
  chongqingdata: any[] = [];
  sichuanlist: any[] = [];
  async created() {
    const res = await getRank();
    const listData = res.data;

    this.chongqingdata = listData.filter((item: any) => item.work_type === 1);
    console.log('chongqingdata: ', this.chongqingdata);

    this.sichuanlist = listData.filter((item: any) => item.work_type === 2);
    console.log('sichuanlist: ', this.sichuanlist);
    this.list =
      this.region === 'Chongqing' ? this.chongqingdata : this.sichuanlist;
  }
  async change(region: any) {
    this.region = region;
    this.list =
      this.region === 'Chongqing' ? this.chongqingdata : this.sichuanlist;
  }
  back() {
    this.$router.push({ path: '/20260901JQDM/home' });
  }
  percent(votes: number) {
    return this.list.length
      ? Math.round((votes / this.list[0].votes) * 100)
      : 0;
  }
}
